import React, { Component } from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import $ from "jquery";
import draftToHtml from "draftjs-to-html";
import { ToastContainer, toast } from "react-toastify";
import Loader from "react-loader-spinner";
import { DialogComponent } from "@syncfusion/ej2-react-popups";

export default class Document extends Component {
  constructor() {
    super();

    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: true,
      });
    };

    this.settings = { effect: "Zoom", duration: 600, delay: 0 };

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.deleteDocumentApi(this.state.editedId);
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({ hideDeletePopup: true });
        },
      },
    ];

    this.state = {
      addTextArea: false,
      editorState: EditorState.createEmpty(),
      documentList: [],
      planDocCharacterCount: 0,
      docCharacterCount: 0,
      showLoader: false,
      editedId: -1,
      languageList: [],
      language: "",
      hideDeletePopup: true,
      showEditAction: false,
      autoTranslateChecked: false,
      hoverId: -1,
      documentCount: 0,
      isDocLimitExceeded: false,
    };
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.editDocument = this.editDocument.bind(this);
    this.editImageSrc = "./assets/images/edit2.png";
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchLanguageApi();
      this.fetchDocumentListApi();
    }, 300);
    var thisComponent = this;
    document.addEventListener("projectChanged", function (event) {
      thisComponent.state.languageList = [];
      thisComponent.state.documentList = [];
      thisComponent.state.addTextArea = false;
      thisComponent.state.language = "";
      thisComponent.state.docCharacterCount = 0;
      thisComponent.projectId = event.projectId;
      thisComponent.fetchLanguageApi(event.projectId);
      thisComponent.fetchDocumentListApi(event.projectId);
    });
  }

  fetchLanguageApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisComponent = this;
    thisComponent.state.showLoader = true;
    $.ajax({
      url: "/api/project-languages-selected",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        thisComponent.state.showLoader = false;
        if (res.success === true) {
          thisComponent.state.languageList = res.result;
          thisComponent.state.language = res.result[0].code;
          thisComponent.setState(thisComponent.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }

  fetchDocumentListApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisComponent = this;
    thisComponent.state.showLoader = true;
    $.ajax({
      url: "/api/document",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
        language: thisComponent.state.language,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        thisComponent.state.showLoader = false;
        if (res.success === true) {
          thisComponent.state.documentList = res.result.documentList;
          if (res.result.documentList.length < res.result.documentCount) {
            thisComponent.state.isDocLimitExceeded = true;
          } else {
            thisComponent.state.isDocLimitExceeded = false;
          }
          thisComponent.setState(thisComponent.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  notifyFailedToLoad(response) {
    if (/null/i.test(response)) {
      this.notifyError();
    } else {
      toast.dismiss();
      toast(<b style={{ color: "red" }}>{response}</b>, {
        position: "top-center",
        color: "red",
      });
    }
  }

  notifyError = () => {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  };

  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const oldContent = this.state.editorState.getCurrentContent();
    if (contentState.getPlainText().length > 1000) {
      const editorState = EditorState.moveFocusToEnd(
        EditorState.push(
          this.state.editorState,
          ContentState.createFromText(oldContent.getPlainText())
        )
      );
      this.state.editorState = editorState;
    } else {
      this.state.docCharacterCount = contentState.getPlainText().length;
      this.state.editorState = editorState;
    }
    this.setState(this.state);
  };

  notifyWarning = (message) => {
    toast.dismiss();
    toast(
      <b>
        <img
          src="./assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  };

  saveDocumentApi = () => {
    var thisController = this;
    if (
      thisController.state.editorState.getCurrentContent().getPlainText() == ""
    ) {
      thisController.notifyWarning("Please enter content");
    } else {
      let data = {
        projectId: localStorage.getItem("currentProjectId"),
        content: draftToHtml(
          convertToRaw(this.state.editorState.getCurrentContent())
        ),
        language: thisController.state.language,
        autoTranslate: document.getElementById("doc-auto-translate").checked,
      };
      $.ajax({
        url: "/api/document",
        async: false,
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
        success: function (res) {
          if (res.success === true) {
            thisController.state.editorState = EditorState.createEmpty();
            thisController.state.addTextArea = false;
            thisController.state.docCharacterCount = 0;
            thisController.fetchDocumentListApi();
            thisController.setState(thisController.state);
            thisController.notifySuccess("Document added successfully");
          } else {
            thisController.notifyFailedToLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        },
      });
    }
  };

  notifySuccess(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="./assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  updateDocumentApi = () => {
    var thisComponent = this;
    if (
      thisComponent.state.editorState.getCurrentContent().getPlainText() == ""
    ) {
      thisComponent.notifyWarning("Please enter content");
    } else {
      let data = {
        id: thisComponent.state.editedId,
        projectId: localStorage.getItem("currentProjectId"),
        content: draftToHtml(
          convertToRaw(this.state.editorState.getCurrentContent())
        ),
        language: thisComponent.state.language,
        autoTranslate: document.getElementById("doc-auto-translate").checked,
      };
      $.ajax({
        url: "/api/document",
        async: false,
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
        success: function (res) {
          if (res.success === true) {
            thisComponent.state.editorState = EditorState.createEmpty();
            thisComponent.state.addTextArea = false;
            thisComponent.state.editedId = -1;
            thisComponent.state.docCharacterCount = 0;
            thisComponent.fetchDocumentListApi();
            thisComponent.setState(thisComponent.state);
            thisComponent.notifySuccess("Document updated successfully");
          } else {
            thisComponent.notifyFailedToLoad(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        },
      });
    }
  };

  editDocument = (id, autoTranslate) => {
    this.state.editedId = id;
    this.state.addTextArea = true;
    this.state.autoTranslateChecked = autoTranslate;
    var docTextArea = document.getElementById("docTextArea" + id).innerHTML;
    this.state.editorState = EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML(docTextArea))
    );
    this.state.docCharacterCount = 0;
    this.setState(this.state);
  };

  handleChangeLang = (e) => {
    this.state.language = e.target.value;
    this.state.addTextArea = false;
    this.state.docCharacterCount = 0;
    this.fetchDocumentListApi();
    this.setState(this.state);
  };

  refreshData = () => {
    var thisController = this;
    thisController.state.documentList = [];
    thisController.state.addTextArea = false;
    thisController.state.docCharacterCount = 0;
    thisController.fetchDocumentListApi();
  };

  deleteDocumentApi = (id) => {
    let thisController = this;
    $.ajax({
      url: "/api/document/" + id,
      async: false,
      method: "DELETE",
      headers: {
        Authorization: "Bearer" + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          thisController.state.addTextArea = false;
          thisController.setState({ hideDeletePopup: true });
          thisController.fetchDocumentListApi();
          thisController.notifySuccess("Document deleted successfully");
        } else {
          thisController.notifyFailedToLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  handleChangeChecked = (e) => {
    let thisController = this;
    thisController.state.autoTranslateChecked = e.target.checked ? true : false;
    thisController.setState(thisController.state);
  };

  handleMouseEnterDoc = (id) => {
    this.state.hoverId = id;
    this.setState(this.state);
  };

  handleMouseLeaveDoc = () => {
    this.state.hoverId = -1;
    this.setState(this.state);
  };

  addDocument = () => {
    if (this.state.isDocLimitExceeded) {
      this.setState({
        addTextArea: true,
        editorState: EditorState.createEmpty(),
        editedId: -1,
        docCharacterCount: 0,
        autoTranslateChecked: false,
      });
    } else {
      this.notifyWarning("Document limit exceeded for the selected plan");
    }
  };

  render() {
    const { editorState } = this.state;
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.showLoader}
          height={300}
          width={50}
          style={{ textAlign: "center" }}
        />

        <div style={{ display: !this.state.showLoader ? "block" : "none" }}>
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          {/* for toaster */}
          <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

          {/* for dialog component */}
          <link href="./assets/css/ej2-base.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="./assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />

          <ToastContainer className="Toast-at-center" />

          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Document Reading</h1>
                  <h6 className="taglineTxt">
                    Make agents learn from passages
                  </h6>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card-body p-0 mb-25">
                    <div className="tab-content col-12 p-0">
                      <div className="tab-pane active show" id="tab_1">
                        <div className="card card-primary mt-3">
                          <div
                            className="card-body raise-form"
                            style={{ minHeight: "450px" }}
                          >
                            <div className="row">
                              <div className="col-sm-6">
                                <h6
                                  className="nav-item"
                                  style={{
                                    color: "#282a65",
                                    marginTop: "10px",
                                  }}
                                >
                                  Provide passages for Agent to learn
                                </h6>
                              </div>
                              <div
                                className="col-sm-4"
                                style={{ marginTop: "1.3rem" }}
                              >
                                <label>Language</label>
                                <select
                                  className="input-group mb-3 form-control select2 "
                                  id="docLanguage"
                                  value={this.state.value}
                                  onChange={this.handleChangeLang}
                                  style={{
                                    marginLeft: "15px",
                                    width: "75%",
                                    height: "30px",
                                    borderRadius: "4px",
                                    backgroundColor: "#F9F9FB",
                                  }}
                                >
                                  {this.state.languageList.map((language) => (
                                    <option value={language.code}>
                                      {language.code}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div
                                className="d-flex flex-row-reverse pt-2 col-sm-2"
                                align="right"
                              >
                                <button
                                  title="Refresh"
                                  onClick={this.refreshData}
                                  type="button"
                                  className="btn action-button"
                                >
                                  <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>

                                <button
                                  className="btn action-button "
                                  title="Add"
                                  id="addMsg"
                                  style={{ marginRight: "-2px" }}
                                  onClick={this.addDocument}
                                >
                                  <img src="assets/images/add_white_24dp.png" />
                                </button>
                              </div>
                            </div>
                            <div className="row">
                              <div
                                className="col-sm-5"
                                style={{
                                  display: this.state.addTextArea
                                    ? "block"
                                    : "none",
                                }}
                              >
                                <Editor
                                  id="editor"
                                  editorState={editorState}
                                  // toolbarClassName="toolbarClassName"
                                  wrapperClassName="demo-wrapper"
                                  editorClassName="demo-editor"
                                  onEditorStateChange={this.onEditorStateChange}
                                  editorStyle={{
                                    minHeight: "190px",
                                    border: "1px solid #0094c8",
                                    padding: "6px",
                                    borderRadius: "5px",
                                  }}
                                />
                                <div className="row">
                                  <div className="col-sm-12">
                                    <label
                                      style={{
                                        display:
                                          this.state.docCharacterCount > 0
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      {this.state.docCharacterCount} characters
                                      of {1000}
                                    </label>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-4">
                                    <button
                                      className="btn action-button"
                                      style={{
                                        marginRight: "-2px",
                                        background: "#FF0000",
                                        display:
                                          this.state.editedId == -1
                                            ? "none"
                                            : "block",
                                      }}
                                      onClick={() =>
                                        this.setState({
                                          hideDeletePopup: false,
                                        })
                                      }
                                    >
                                      Delete
                                    </button>
                                  </div>
                                  <div className="col-sm-8" align="right">
                                    <div className="row">
                                      <div
                                        className="col-sm-7 row"
                                        style={{ marginTop: "15px" }}
                                      >
                                        <label
                                          style={{
                                            display:
                                              this.state.language == "ENGLISH"
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          Auto translate:&nbsp;
                                        </label>
                                        <label
                                          class="switch"
                                          title="Auto translate"
                                          style={{
                                            display:
                                              this.state.language == "ENGLISH"
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            id="doc-auto-translate"
                                            // defaultChecked={this.state.autoTranslateChecked}
                                            checked={
                                              this.state.autoTranslateChecked
                                            }
                                            onChange={this.handleChangeChecked}
                                          />
                                          <span class="slider round"></span>
                                        </label>
                                      </div>
                                      <div
                                        className="col-sm-6 row"
                                        align="right"
                                      >
                                        <button
                                          className="btn action-button"
                                          style={{ marginRight: "-2px" }}
                                          onClick={
                                            this.state.editedId == -1
                                              ? this.saveDocumentApi
                                              : this.updateDocumentApi
                                          }
                                        >
                                          Save
                                        </button>
                                        <button
                                          className="btn action-button"
                                          onClick={this.refreshData}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-7">
                                <div className="row">
                                  {this.state.documentList.map((document) => (
                                    <div>
                                      <div
                                        className="textarea"
                                        id={"docTextArea" + document.id}
                                        style={{
                                          border: "1px solid #0094c8",
                                          height: "150px",
                                          width: "150px",
                                          borderRadius: "10px",
                                          margin: "10px",
                                          overflow: "hidden",
                                          padding: "6px",
                                          backgroundColor:
                                            this.state.hoverId == document.id
                                              ? "#F0F0F0"
                                              : "#ffffff",
                                        }}
                                        onMouseEnter={(e) => {
                                          this.handleMouseEnterDoc(document.id);
                                        }}
                                        onMouseLeave={(e) => {
                                          this.handleMouseLeaveDoc();
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: document.content,
                                        }}
                                      ></div>
                                      <img
                                        className="img-responsive"
                                        id="edit-button"
                                        onMouseEnter={(e) => {
                                          this.handleMouseEnterDoc(document.id);
                                        }}
                                        style={{
                                          backgroundColor: "#282a65",
                                          borderRadius: "5px",
                                          padding: "1px",
                                          marginTop: "-94%",
                                          marginLeft: "78%",
                                          display:
                                            this.state.hoverId == document.id
                                              ? "block"
                                              : "none",
                                          cursor: "pointer",
                                        }}
                                        src={this.editImageSrc}
                                        onClick={() =>
                                          this.editDocument(
                                            document.id,
                                            document.autoTranslate
                                          )
                                        }
                                      ></img>
                                    </div>
                                  ))}
                                </div>
                              </div>
                              <div
                                className="col-sm-10"
                                align="center"
                                style={{
                                  display:
                                    this.state.documentList.length == 0 &&
                                    this.state.addTextArea == false
                                      ? "block"
                                      : "none",
                                  marginTop: "20%",
                                  height: "200px",
                                  paddingLeft: "15%",
                                }}
                              >
                                <div
                                  style={{
                                    width: "40%",
                                    fontSize: "22px",
                                    color: "#282a65",
                                    marginTop: "-50px",
                                  }}
                                >
                                  No document added yet!
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Dialog Component For Deletion Confirmation*/}
          <DialogComponent
            width="400px"
            animationSettings={this.settings}
            header="Document Reading"
            showCloseIcon={true}
            buttons={this.buttons}
            ref={(dialog) => (this.dialogInstance = dialog)}
            visible={!this.state.hideDeletePopup}
            close={this.dialogClose}
          >
            <img
              src="assets/images/warn.svg"
              style={{ paddingRight: "0px", height: "20px", width: "20px" }}
              content=""
            />
            &nbsp;Do you want to delete the Document ?<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to
            delete or press 'No' to decline.
          </DialogComponent>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/projectmgmt/faq/Document.js